import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Hero from "../../../components/Hero";
import FormatDate from '../../../components/FormatDate';
import Loader from '../../../components/Loader';
import Button from '../../../components/Button';
import ButtonShareWsp from '../../../components/ButtonShareWsp';
import Footer from '../../../components/Footer';
import LinkBack from '../../../components/LinkBack';
import './index.css';

export default function UuidNews() {
    const { uuid_news } = useParams();
    const navigate = useNavigate();

    const [news, setNews] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (uuid_news) {
            const apiUrl = `/api/news/?uuid_news=${uuid_news}`;
            const fetchData = async () => {
                try {
                    const response = await fetch(apiUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    const jsonData = await response.json();
                    setNews(jsonData);
                    setLoading(false);
                } catch (e) {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [uuid_news]);

    if (loading || news === null) {
        return <Loader topAvance={150} />;
    }

    const handleBackNavigate = () => {
        navigate(-1)
    }
    return (
        <main className="g-main uuid_news">
            <Hero title={news.title} description={<FormatDate date={news.date} format="xl" />} size='s' />
            <section className="content-main">
                <LinkBack to="/noticias/" text="Volver a noticias" />
                <div className="g-share-wsp">
                    <ButtonShareWsp
                        url={window.location.href}
                        text={`Quiero compartir esta noticia contigo: \n(Por ${news.role}) \n${news.full_name}\n${news.title}\n\n${news.news}`}
                    >
                        <Button label="Compartir" />
                    </ButtonShareWsp>
                </div>
                <div className="content-data-news">
                    <p className="author-news">Por {news.role} {news.full_name}</p>
                    <p className="news-content">{news.news}</p>
                </div>
            </section>
            <Footer />
        </main>
    );
}